import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { getPrefixLocale } from "@/utils/helper";
import { useLocale } from "@/hooks/useLocale";

const ArticleDropdown = ({ articleDropdownData = {} }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const router = useRouter();
  const locale = useLocale();
  const handleToggle = () => setOpen(prev => !prev);
  useEffect(() => {
    if (!open) return;
    function handleClickOutside(event) {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [open]);

  const heading = articleDropdownData.heading || "";
  const items = articleDropdownData.item || [];
  const showBorder = true;

  const prefixLocale = getPrefixLocale(locale, false);

  return (
    <div className={styles.wrapper}>
      <div className="koh-article-header">
        <div className="koh-article-controls contained">
          {heading && (
            <button
              ref={buttonRef}
              className={`koh-article-select${open ? " open" : ""}`}
              onClick={handleToggle}
              type="button"
            >
              {heading}
            </button>
          )}
          {items.length > 0 && (
            <ul className={`koh-article-set${open ? " open" : ""}`}>
              {items.map((item, idx) =>
                item?.fields?.label && item?.fields?.url ? (
                  <li key={item.sys?.id || idx}>
                    <a
                      className={`${item.active ? "active" : ""} hover:!bg-[#666] hover:!text-[#337ab7]`}
                      href={`${prefixLocale}${item.fields.url}`}
                    >
                      {item.fields.label}
                    </a>
                  </li>
                ) : null
              )}
            </ul>
          )}
        </div>
      </div>
      <div className="koh-article-controls contained">
        <div
          className={showBorder ? styles.cardDivider : styles.cardDivide}
        ></div>
      </div>
    </div>
  );
};
ArticleDropdown.defaultProps = {
  articleDropdownData: {
    heading: "",
    items: [],
  },
};

ArticleDropdown.propTypes = {
  articleDropdownData: PropTypes.shape({
    heading: PropTypes.string,
    item: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default ArticleDropdown;
